import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import AboutHero from "@/pages/about/components/AboutHero";
import PositioningSection from "@/pages/about/components/PositioningSection";
import PrinciplesSection from "@/pages/about/components/PrinciplesSection";
import RhythmSection from "@/pages/about/components/RhythmSection";
import ContactSection from "@/pages/about/components/ContactSection";
import { useSeo } from "@/hooks/useSeo";
import { useScrollToHash } from "@/hooks/useScrollToHash";
import { SITE_EMAIL, SITE_NAME, SITE_URL } from "@/utils/format";

const aboutJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: `关于我们 - ${SITE_NAME}`,
    url: `${SITE_URL}/about`,
    inLanguage: "zh-CN",
    description:
      "了解瓜友会网的定位、内容原则与更新节奏：做一份能看明白的吃瓜记录。",
    isPartOf: {
      "@type": "WebSite",
      name: SITE_NAME,
      url: `${SITE_URL}/`,
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: `${SITE_URL}/`,
    email: SITE_EMAIL,
    description:
      "瓜友会网是聚合全网热点的吃瓜资讯站，实时更新今日爆料、热门瓜田与新鲜瓜进展。",
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "爆料投稿与内容反馈",
      email: SITE_EMAIL,
      availableLanguage: ["zh-CN"],
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "首页",
        item: `${SITE_URL}/`,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "关于我们",
        item: `${SITE_URL}/about`,
      },
    ],
  },
];

export default function AboutPage() {
  useScrollToHash();
  useSeo({
    title: "关于我们 - 瓜友会网 | 做一份能看明白的吃瓜记录",
    description:
      "瓜友会网由一群普通瓜友搭建，专注把公开信息整理成清晰的爆料时间线。了解我们的网站定位、五条内容原则、每日更新节奏，以及爆料投稿与联系方式。",
    keywords: "瓜友会网,关于我们,内容原则,爆料投稿,吃瓜现场",
    path: "/about",
    jsonLd: aboutJsonLd,
  });

  return (
    <div className="flex flex-col min-h-screen bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <AboutHero />
        <div className="w-full px-4 md:px-8 py-4 md:py-5 bg-background-100 border-b border-background-200">
          <Breadcrumbs
            items={[{ label: "首页", to: "/" }, { label: "关于我们" }]}
          />
        </div>
        <PositioningSection />
        <PrinciplesSection />
        <RhythmSection />
        <ContactSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}